"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureToggle = void 0;
exports.featureToggle = {
    importSpreadSheet: false,
    exportSpreadSheet: false,
};
